import { Box, Select, TextField, Typography, styled } from "@mui/material";
import {
  APP_COLOR,
  APP_HOVER_COLOR,
  BORDER_COLOR,
  BUTTON_TEXT_COLOR,
  FONT_FAMILY,
  SKIP_BUTTON_BACKGROUND_COLOR,
  SKIP_BUTTON_TEXT_COLOR,
} from "../../theme";

export const styles = {
  mainContainer: {
    width: "100%",
    margin: "25px",
    overflowY: "scroll",
    scrollbarWidth: "none",
    maxHeight: "95vh",
    "&::-webkit-scrollbar": {
      display: "none",
    },
  } as const,
  profileBackground: {
    height: "20vh",
    marginTop: "20px",
    background:
      "var(--Gradient-Linear-Color-09, linear-gradient(45deg, #A6C0FE 0%, #FFEAF6 100%))",
  } as const,
  userName: {
    color: "var(--colors-text-text-primary-900, #F8F9FA)",
    fontSize: "30px",
    fontWeight: 400,
    lineHeight: "38px",
  } as const,
  userNameContainer: {
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
    alignItems: "center",
  } as const,
  avatarContainer: {
    display: "flex",
    borderBottom: `1px solid ${BORDER_COLOR}`,
    paddingBottom: "15px",
  } as const,
  button: {
    borderRadius: "var(--radius-md, 8px)",
    textTransform: "none",
    color: BUTTON_TEXT_COLOR,
    "&:hover": {
      backgroundColor: APP_HOVER_COLOR,
    },
    backgroundColor: APP_COLOR,
    fontFamily: FONT_FAMILY,
    fontSize: 16,
    fontWeight: "bold",
  } as const,
  buttonBox: {
    display: "flex",
    gap: "15px",
    margin: "10px"
  } as const,
  skipButton: {
    borderRadius: "var(--radius-md, 8px)",
    border:
      "1px solid var(--Component-colors-Components-Buttons-Secondary-button-secondary-border, #4C5155)",
    background: SKIP_BUTTON_BACKGROUND_COLOR,
    boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
    color: SKIP_BUTTON_TEXT_COLOR,
    fontSize: 16,
    textTransform: "none",
  } as const,
  update: {
    backgroundColor: "none",
    color: "white",
    textTransform: "none",
  } as const,
  loadingContainer: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "20vh",
  } as const,
  avatar: {
    width: "200px", height: "200px", marginTop: -7
  } as const,
};

export const FirstNameContainer = styled(Box)(({ theme }) => ({
  padding: "15px",
  display: "flex",
  borderBottom: `1px solid ${BORDER_COLOR}`,
  [theme.breakpoints.down("sm")]: {
    flexDirection: "column",
  },
}));

export const CustomLeftTitle = styled(Typography)(({ theme }) => ({
  width: "40%",
  [theme.breakpoints.down("sm")]: {
    width: "100%",
  },
}));

export const CustomSelectField = styled(Select)(({ theme }) => ({
  width: "40%",
  [theme.breakpoints.down("sm")]: {
    width: "100%",
  },
}));
export const CustomTextField = styled(TextField)(({ theme }) => ({
  width: "40%",
  [theme.breakpoints.down("sm")]: {
    width: "100%",
  },
}));
export const CustomBioContainer = styled(Box)(({ theme }) => ({
  width: "40%",
  [theme.breakpoints.down("sm")]: {
    width: "100%",
  },
}));

export const TopContainer = styled(Box)(({ theme }) => ({
  [theme.breakpoints.down("sm")]: {
    display: "none",
  },
}));

export const MobileScreenSaveContainer = styled(Box)(({ theme }) => ({
  [theme.breakpoints.up("sm")]: {
    // display: "none",
  },
}));
export const SmallScreenBottomContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  gap: "15px",
  margin: "10px",
  justifyContent: "center",
  width: "100%",
}));
